export default __webpack_public_path__ + "static/media/dinner2.897df94a.png";